import { render, staticRenderFns } from "./GstPrintDetail.vue?vue&type=template&id=406e3f23&scoped=true"
import script from "./GstPrintDetail.vue?vue&type=script&lang=js"
export * from "./GstPrintDetail.vue?vue&type=script&lang=js"
import style0 from "./GstPrintDetail.vue?vue&type=style&index=0&id=406e3f23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406e3f23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406e3f23')) {
      api.createRecord('406e3f23', component.options)
    } else {
      api.reload('406e3f23', component.options)
    }
    module.hot.accept("./GstPrintDetail.vue?vue&type=template&id=406e3f23&scoped=true", function () {
      api.rerender('406e3f23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gstreport/GstPrintDetail.vue"
export default component.exports